import React, { useEffect, useCallback, useState } from 'react'
import { ReactComponent as CloseIcon } from 'src/images/icon-close-v2.svg'
import useStyles from './SuccessScreen.styles'
import { useCloseAvailyContext } from '@context/CloseAvailyContext'
import anaService from 'src/services/ana'
import Page from '@components/Page'
import { useChoiceDispatch, resetDefaultChoice, useChoiceState } from '@context/ChoiceContext'
import { useQueryClient } from 'react-query'
import { SuccessScreenBody } from './components/SuccessScreenBody/SuccessScreenBody'
import { useLinkToAnaParams } from '@hooks/useLinkToAnaParams'
import { useConfig } from '@context/ConfigurationContext'

export const SuccessScreen = () => {
  const classes = useStyles()
  const { linkToAna = '', asModal } = useConfig()
  const closeAvaily = useCloseAvailyContext()
  const dispatch = useChoiceDispatch()
  const queryClient = useQueryClient()
  const linkToAnaParams = useLinkToAnaParams()
  const { selectedBookableDateAndTime, appointmentDuration } = useChoiceState()
  const [openAna, setOpenAna] = useState(false)

  const onCloseButtonClick = () => {
    // Clear choice after successful flow
    dispatch(resetDefaultChoice())
    queryClient.clear()
    closeAvaily && closeAvaily()
  }

  const initAna = useCallback(() => {
    const code = linkToAna.split('code=')[1]
    const params = `?code=${code}${linkToAnaParams}`

    anaService.init({
      wrapperId: 'ana-wrapper',
      params,
      transform: {
        beforeAppend: (iframe: HTMLIFrameElement) => {
          iframe.className = classes.anaIframe

          if (!asModal) {
            iframe.style.height = '100vh'
          }
        },
      },
      closeAvaily,
    })
  }, [asModal, classes.anaIframe, closeAvaily, linkToAna, linkToAnaParams])

  useEffect(() => {
    const redirect = (event: { data: { message: string; destination: string } }) => {
      if (event.data && event.data.destination && event.data.message === 'redirect') {
        window.location.href = event.data.destination
      }
    }

    window.addEventListener('message', redirect)

    return () => window.removeEventListener('message', redirect)
  }, [])

  useEffect(() => {
    const availyWrapper = document.getElementById('availyWrapper')

    if (openAna) {
      initAna()
    }

    return () => availyWrapper?.removeAttribute('style')
  }, [initAna, openAna])

  if (openAna) return <div className={classes.anaWrapper} id="ana-wrapper" />

  return (
    <Page
      header={
        <div className={classes.closeIcon}>{asModal && closeAvaily && <CloseIcon onClick={onCloseButtonClick} />}</div>
      }
      body={
        <SuccessScreenBody
          openAna={() => setOpenAna(true)}
          appointmentDuration={appointmentDuration}
          selectedBookableDateAndTime={selectedBookableDateAndTime}
        />
      }
      footer={undefined}
    />
  )
}
